var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.accessToken ? _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/mypage/myinfo"
    }
  }, [_c('span', [_vm._v("마이페이지")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.navigate($event);
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("로그아웃")))])])], 1)]) : _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/join/type"
    }
  }, [_c('span', [_vm._v("회원가입")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.navigate($event);
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("로그인")))])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }